// VCIN Brand: Always use VCIN_COLORS from constants.js - never use Tailwind blue classes
import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { 
  LayoutDashboard, 
  Users, 
  MapPin, 
  Eye, 
  Car, 
  Settings,
  LogOut,
  Shield,
  BarChart3
} from 'lucide-react';
import { VCIN_COLORS } from '../../styles/constants';

const NAV_ITEMS = [
  { path: '/admin', icon: LayoutDashboard, label: 'Dashboard', exact: true },
  { path: '/admin/officers', icon: Users, label: 'Officers' },
  { path: '/admin/sites', icon: MapPin, label: 'Sites' },
  { path: '/admin/sightings', icon: Eye, label: 'Sightings' },
  { path: '/admin/known-vehicles', icon: Car, label: 'Known Vehicles' },
  { path: '/admin/statistics', icon: BarChart3, label: 'Statistics' },
  { path: '/admin/account', icon: Settings, label: 'Account' },
];

export default function AdminSidebar() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => navigate('/signout');

  return (
    <aside 
      className="fixed left-0 top-0 h-full flex flex-col"
      style={{ 
        width: '240px', 
        backgroundColor: VCIN_COLORS.primary
      }}
      data-testid="admin-sidebar"
    >
      {/* Logo Section */}
      <div className="p-6 flex items-center gap-3 border-b border-white/10">
        <div 
          className="w-10 h-10 rounded-lg flex items-center justify-center"
          style={{ backgroundColor: 'rgba(255,255,255,0.15)' }}
        >
          <Shield className="w-6 h-6 text-white" />
        </div>
        <span className="text-white font-bold text-xl">VCIN</span>
      </div>

      {/* Navigation */}
      <nav className="flex-1 py-4">
        {NAV_ITEMS.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.exact}
            className="block"
            data-testid={`nav-${item.label.toLowerCase().replace(' ', '-')}`}
          >
            {({ isActive }) => (
              <div
                className="flex items-center gap-3 px-6 py-3 mx-2 rounded-lg transition-all"
                style={{
                  backgroundColor: isActive ? 'rgba(255,255,255,0.12)' : 'transparent',
                  borderLeft: isActive ? `3px solid ${VCIN_COLORS.gold}` : '3px solid transparent',
                  marginLeft: isActive ? '0' : '8px',
                  paddingLeft: isActive ? '21px' : '24px'
                }}
              >
                <item.icon 
                  className="w-5 h-5" 
                  style={{ color: isActive ? '#FFFFFF' : 'rgba(255,255,255,0.7)' }}
                />
                <span 
                  className="font-medium"
                  style={{ color: isActive ? '#FFFFFF' : 'rgba(255,255,255,0.7)' }}
                >
                  {item.label}
                </span>
              </div>
            )}
          </NavLink>
        ))}
      </nav>

      {/* Logout Button */}
      <div className="p-4 border-t border-white/10">
        <button
          onClick={handleLogout}
          className="flex items-center gap-3 w-full px-4 py-3 rounded-lg transition-colors hover:bg-white/10"
          data-testid="logout-btn"
        >
          <LogOut className="w-5 h-5" style={{ color: 'rgba(255,255,255,0.7)' }} />
          <span className="font-medium" style={{ color: 'rgba(255,255,255,0.7)' }}>
            Sign Out
          </span>
        </button>
      </div>
    </aside>
  );
}
